"use client";

var __jsx = React.createElement;
import React from "react";
import { BREAKPOINTS } from "@lib/constants";
import { MuscleButton } from "@modules/shared/components/buttons";
import { useTranslations } from "next-intl";
import LoginFlow from "@modules/shared/auth-flows/flows/login-flow";
import RegisterFlow from "@modules/shared/auth-flows/flows/register-flow";
import { useMediaQuery } from "react-responsive";
import APP_CONFIGURATION from "@lib/app.config";
import useAuthModals from "@lib/hooks/use-auth-modals";
import { permissionsManager } from "@lib/permissions/permissions-manager";
const HeaderAuthButtons = () => {
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const t = useTranslations("Shared.Auth");
  const {
    loginFunction,
    registerFunction,
    loginModalIsOpen,
    setLoginModalIsOpen,
    registerModalIsOpen,
    setRegisterModalIsOpen
  } = useAuthModals();
  const showRegisterButton = permissionsManager.showRegisterButton();
  return permissionsManager.canShowLoginButton() ? __jsx("div", {
    className: "flex flex-row gap-2 items-center"
  }, __jsx(MuscleButton, {
    dataTestId: "header-login-button",
    onClick: loginFunction,
    variant: "solidXs"
  }, t("LOGIN")), showRegisterButton && __jsx(MuscleButton, {
    dataTestId: "header-register-button",
    variant: APP_CONFIGURATION.config.appName === "Shopstar" ? "solidXs" : "outlineXs",
    onClick: registerFunction
  }, t("REGISTER")), __jsx(LoginFlow, {
    isOpen: loginModalIsOpen,
    setIsOpen: setLoginModalIsOpen
  }), __jsx(RegisterFlow, {
    isOpen: registerModalIsOpen,
    setIsOpen: setRegisterModalIsOpen
  })) : null;
};
export default HeaderAuthButtons;